import { ADMIN_KEYS, ALWAYS_ON_MODULE_NAMES, EXCEPTION_MODULE, JOB_KEYS, MODULE_NAMES } from './keys';

export { ADMIN_KEYS, ALWAYS_ON_MODULE_NAMES, EXCEPTION_MODULE, JOB_KEYS, MODULE_NAMES };

export type JobKey = (typeof JOB_KEYS)[number];
export type AdminKey = (typeof ADMIN_KEYS)[number];
export type PermissionKey = JobKey | AdminKey;
export type ModuleName = (typeof MODULE_NAMES)[number];

const jobKeys: ReadonlySet<string> = new Set(JOB_KEYS);
const adminKeys: ReadonlySet<string> = new Set(ADMIN_KEYS);
const alwaysOn: ReadonlySet<string> = new Set(ALWAYS_ON_MODULE_NAMES);

export const isJobKey = (key: string): key is JobKey => jobKeys.has(key);

export const isAdminKey = (key: string): key is AdminKey => adminKeys.has(key);

export const isKnownKey = (key: string): key is PermissionKey => jobKeys.has(key) || adminKeys.has(key);

export const moduleOf = (key: PermissionKey): ModuleName => key.slice(0, key.indexOf('.')) as ModuleName;

export const isAlwaysOnModule = (module: string): boolean => alwaysOn.has(module);
